import { useEffect, useMemo, useState } from "react";
import Header from "../components/Header";

const STAFF_SECTIONS = [
  {
    key: "leadership",
    title: "Leadership",
    subtitle: "Game leadership and community management.",
    members: [
      {
        discordId: "972599697229365278",
        name: "Gus",
        role: "Founder / Game Lead",
      },
      {
        discordId: "1351799105189318806",
        name: "Cipher",
        role: "Secondary Game Lead",
      },
      {
        discordId: "816509777911742486",
        name: "Ethan",
        role: "Community Manager",
      },
    ],
  },
  {
    key: "developers",
    title: "Developers & Designers",
    subtitle: "The team building and designing Outfall.",
    members: [
      {
        discordId: "889184335427682375",
        name: "Batpoliceman",
        role: "Developer",
      },
      {
        discordId: "874955311226691604",
        name: "Weyexx",
        role: "Developer",
      },
      {
        discordId: "1224512361793327117",
        name: "Stilly",
        role: "Designer",
      },
    ],
  },
  {
    key: "moderators",
    title: "Moderation",
    subtitle: "Keeping the community safe and fair.",
    members: [
      {
        discordId: "893961034954579978",
        name: "EmergencyProGaming1",
        role: "Moderator",
      },
      {
        discordId: "1416209242838401064",
        name: "kushal061729",
        role: "Moderator",
      },
    ],
  },
];

function DiscordIcon() {
  return (
    <svg
      viewBox="0 0 127.14 96.36"
      className="h-6 w-6 shrink-0 fill-current sm:h-7 sm:w-7"
      aria-hidden="true"
    >
      <path d="M107.7,8.07A105.15,105.15,0,0,0,81.47,0a72.06,72.06,0,0,0-3.36,6.83A97.68,97.68,0,0,0,49,6.83,72.37,72.37,0,0,0,45.64,0,105.89,105.89,0,0,0,19.39,8.09C2.79,32.65-1.71,56.6.54,80.21A105.73,105.73,0,0,0,32.71,96.36a77.7,77.7,0,0,0,6.89-11.11,68.42,68.42,0,0,1-10.85-5.18c.91-.66,1.8-1.34,2.66-2a75.57,75.57,0,0,0,64.32,0c.87.71,1.76,1.39,2.66,2a68.68,68.68,0,0,1-10.87,5.19,77,77,0,0,0,6.89,11.1,105.25,105.25,0,0,0,32.19-16.14C129.24,52.84,122.09,29.11,107.7,8.07ZM42.45,65.69C36.18,65.69,31,60,31,53s5-12.74,11.43-12.74S54,46,53.89,53,48.84,65.69,42.45,65.69Zm42.24,0C78.41,65.69,73.25,60,73.25,53S78.26,40.26,84.69,40.26,96.23,46,96.12,53,91.08,65.69,84.69,65.69Z" />
    </svg>
  );
}

function openDiscordProfile(event, discordAppUrl, discordWebUrl) {
  event.preventDefault();

  const isMobile =
    /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(
      navigator.userAgent,
    );

  if (isMobile) {
    window.open(discordWebUrl, "_blank", "noopener,noreferrer");
    return;
  }

  window.location.href = discordAppUrl;

  setTimeout(() => {
    window.open(discordWebUrl, "_blank", "noopener,noreferrer");
  }, 700);
}

function StaffCard({ member }) {
  const discordAppUrl = `discord://-/users/${member.discordId}`;
  const discordWebUrl = `https://discord.com/users/${member.discordId}`;

  return (
    <article className="scroll-shine outfall-card group relative overflow-hidden rounded-[22px] border border-[#ffb56f]/25 bg-black/50 p-5 text-center backdrop-blur-md transition hover:-translate-y-1 hover:border-[#ffd978]/70 hover:shadow-[0_0_35px_rgba(255,143,107,0.25)] sm:rounded-[28px] sm:p-8">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(255,217,120,0.18),transparent_45%)] opacity-0 transition group-hover:opacity-100" />

      <div className="relative z-10 min-w-0">
        <div className="mx-auto h-24 w-24 overflow-hidden rounded-full border-4 border-[#ffd978] bg-black shadow-[0_0_25px_rgba(255,217,120,0.35)] sm:h-32 sm:w-32">
          {member.avatarUrl ? (
            <img
              src={member.avatarUrl}
              alt={`${member.name} Discord avatar`}
              className="h-full w-full object-cover"
              draggable="false"
            />
          ) : (
            <div className="flex h-full w-full items-center justify-center text-3xl font-black text-[#ffd978] sm:text-4xl">
              ?
            </div>
          )}
        </div>

        <a
          href={discordWebUrl}
          onClick={(event) =>
            openDiscordProfile(event, discordAppUrl, discordWebUrl)
          }
          className="mx-auto mt-5 flex w-full max-w-full items-center justify-center gap-3 overflow-hidden whitespace-nowrap text-center font-black leading-none text-[#ffd978] transition hover:text-white hover:drop-shadow-[0_0_12px_#ffd978] sm:mt-6"
          title={`Open ${member.name} on Discord`}
        >
          <span className="block max-w-full whitespace-nowrap text-[clamp(1.15rem,6vw,2.25rem)] leading-none">
            {member.name}
          </span>
        </a>

        <p className="mt-3 text-base font-black uppercase leading-tight text-[#ffb56f] sm:text-lg">
          {member.role}
        </p>

        {member.username && (
          <a
            href={discordWebUrl}
            onClick={(event) =>
              openDiscordProfile(event, discordAppUrl, discordWebUrl)
            }
            className="mx-auto mt-3 flex w-full max-w-full items-center justify-center gap-2 overflow-hidden whitespace-nowrap text-[clamp(0.7rem,3vw,0.875rem)] font-bold text-white/45 transition hover:text-[#ffd978]"
            title={`Open ${member.username} on Discord`}
          >
            <span className="block max-w-full whitespace-nowrap">
              @{member.username}
            </span>
            <DiscordIcon />
          </a>
        )}
      </div>
    </article>
  );
}

export default function StaffTeam() {
  const [sections, setSections] = useState([]);
  const [loadingSection, setLoadingSection] = useState("Loading staff team...");

  const totalStaff = useMemo(() => {
    return STAFF_SECTIONS.reduce(
      (total, section) => total + section.members.length,
      0,
    );
  }, []);

  useEffect(() => {
    let cancelled = false;

    async function loadMember(member) {
      try {
        const res = await fetch("/api/check-staff-role", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            discord_id: member.discordId,
          }),
        });

        const data = await res.json();

        return {
          ...member,
          avatarUrl: data.user?.avatarUrl || null,
          username: data.user?.globalName || data.user?.username || null,
          hasRole: data.hasRole || false,
          permissions: data.permissions || {},
        };
      } catch (err) {
        console.error("Failed to load Discord user:", err);

        return {
          ...member,
          avatarUrl: null,
          username: null,
          hasRole: false,
          permissions: {},
        };
      }
    }

    async function loadStaffSections() {
      const loadedSections = [];

      for (const section of STAFF_SECTIONS) {
        if (cancelled) return;

        setLoadingSection(`Loading ${section.title}...`);

        const loadedMembers = [];

        for (const member of section.members) {
          const loadedMember = await loadMember(member);
          loadedMembers.push(loadedMember);
        }

        loadedSections.push({
          ...section,
          members: loadedMembers,
        });

        if (!cancelled) {
          setSections([...loadedSections]);
        }
      }

      if (!cancelled) {
        setLoadingSection("");
      }
    }

    loadStaffSections();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <main className="min-h-screen overflow-hidden bg-[#050505] text-white">
      <Header />

      <section className="relative px-4 pb-14 pt-28 sm:px-6 sm:pb-20 sm:pt-36 md:px-[7%]">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(255,217,120,0.22),transparent_34%),radial-gradient(circle_at_bottom_right,rgba(255,143,107,0.18),transparent_38%)]" />
        <div className="absolute inset-0 bg-[linear-gradient(to_top,#050505_0%,transparent_45%)]" />

        <div className="relative z-10 max-w-5xl">
          <p className="text-sm font-black uppercase tracking-wide text-[#ffb56f] sm:text-base">
            Outfall Staff
          </p>

          <h1 className="mt-3 text-[clamp(44px,16vw,130px)] leading-[0.85] text-[#ffd978] drop-shadow-[0_0_22px_#ff8f6b]">
            MEET THE
            <br />
            TEAM.
          </h1>

          <p className="mt-5 max-w-2xl text-base font-bold leading-relaxed text-white/80 sm:mt-6 sm:text-xl md:text-2xl">
            The people helping build, manage, and support Outfall.
          </p>

          <p className="mt-4 text-xs font-black uppercase tracking-wide text-white/35 sm:text-sm">
            {totalStaff} Staff Members
          </p>
        </div>
      </section>

      <section className="relative z-10 space-y-14 px-4 pb-20 sm:space-y-20 sm:px-6 sm:pb-24 md:px-[7%]">
        {sections.map((section) => (
          <div key={section.key}>
            <div className="mb-6 flex flex-col items-start justify-between gap-4 sm:mb-8 sm:flex-row sm:items-end">
              <div className="min-w-0">
                <p className="text-sm font-black uppercase leading-snug text-[#ffb56f] sm:text-base">
                  {section.subtitle}
                </p>

                <h2 className="mt-2 text-[clamp(34px,12vw,78px)] leading-none text-[#ffd978] drop-shadow-[0_0_14px_#ff8f6b]">
                  {section.title}
                </h2>
              </div>

              <p className="rounded-full border border-[#ffd978]/30 bg-black/40 px-4 py-2 text-xs font-black uppercase text-[#ffd978] sm:text-sm">
                {section.members.length} Members
              </p>
            </div>

            <div className="grid grid-cols-1 gap-5 sm:gap-6 md:grid-cols-2 xl:grid-cols-3">
              {section.members.map((member) => (
                <StaffCard key={member.discordId} member={member} />
              ))}
            </div>
          </div>
        ))}

        {loadingSection && (
          <div className="rounded-[22px] border border-[#ffb56f]/25 bg-black/50 p-6 text-center backdrop-blur-md sm:rounded-[28px] sm:p-10">
            <p className="text-xl font-black text-[#ffd978] sm:text-2xl">
              {loadingSection}
            </p>
          </div>
        )}
      </section>
    </main>
  );
}
